export const BUBBLE_DESIGN = ['standard', 'expanded_bubble'];
export const WIDGET_DESIGN = ['standard', 'flat'];
export const DARK_MODE = ['light', 'auto', 'dark'];
export const WIDGET_MODE = ['default', 'chatOnly'];

// LE TRACE DE LA BULLE PAR DEFAUT, ICI PARCE QUE DEUX MODULES LE DESSINENT et qu'ils ne peuvent
// pas s'importer l'un l'autre : `bubbleHelpers` la pose dans la page du client, `lanceur` la
// montre dans la grille de reglages. Ce fichier n'importe rien, donc il n'y a pas de cycle.
export const bubbleSVG =
  'M240.808 240.808H122.123C56.6994 240.808 3.45695 187.562 3.45695 122.122C3.45695 56.7031 56.6994 3.45697 122.124 3.45697C187.566 3.45697 240.808 56.7031 240.808 122.122V240.808Z';
